import actionTypes from "../actionTypes";
import logger from "../../../utils/logger";


export const logoutUser = () => ({
  type: actionTypes.LOGOUT_USER,
});

export const saveFilterOptions = filterOptions => ({
  type: actionTypes.SAVE_FILTERS,
  payload: filterOptions,
});

export const saveSelectedFilters = selectedFilters => ({
  type: actionTypes.SAVE_SELECTED_FILTERS,
  payload: selectedFilters,
});

export const saveCartDetails = cartDetails => ({
  type: actionTypes.SAVE_CART_DETAILS,
  payload: cartDetails,
});

export const addEntry = entry => ({
  type: actionTypes.ADD_ENTRY,
  payload: entry,
});

export const saveCurrentEntry = currentEntry => ({
  type: actionTypes.SAVE_CURRENT_ENTRY,
  payload: currentEntry,
});

export const addToCartTotalAmount = currentPrice => ({
  type: actionTypes.ADD_TO_TOTAL_AMOUNT,
  payload: currentPrice,
});

export const setCartTotalAmount = total => ({
  type: actionTypes.SET_TOTAL_AMOUNT,
  payload: total,
});

export const resetTotalAmount = () => ({
  type: actionTypes.RESET_TOTAL_AMOUNT,
});

// Countries actions
export const setCountries = countries => {
  logger.log("🔴 [Redux Action] setCountries dispatched:", {
    countriesCount: countries?.length || 0,
    firstCountry: countries?.[0]?.name || "N/A",
  });
  return {
    type: actionTypes.SET_COUNTRIES,
    payload: countries,
  };
};

export const setCountriesLoading = loading => {
  logger.log("🟡 [Redux Action] setCountriesLoading dispatched:", loading);
  return {
    type: actionTypes.SET_COUNTRIES_LOADING,
    payload: loading,
  };
};

export const setCountriesError = error => {
  logger.log("🔴 [Redux Action] setCountriesError dispatched:", error);
  return {
    type: actionTypes.SET_COUNTRIES_ERROR,
    payload: error,
  };
};

export const clearCountries = () => {
  logger.log("🗑️ [Redux Action] clearCountries dispatched");
  return {
    type: actionTypes.CLEAR_COUNTRIES,
  };
};

// Currencies actions
export const setCurrencies = currencies => ({
  type: actionTypes.SET_CURRENCIES,
  payload: currencies,
});

export const setCurrenciesLoading = loading => ({
  type: actionTypes.SET_CURRENCIES_LOADING,
  payload: loading,
});

export const setCurrenciesError = error => ({
  type: actionTypes.SET_CURRENCIES_ERROR,
  payload: error,
});

export const clearCurrencies = () => ({
  type: actionTypes.CLEAR_CURRENCIES,
});

// Service Categories actions
export const setServiceCategories = categories => ({
  type: actionTypes.SET_SERVICE_CATEGORIES,
  payload: categories,
});

export const setServiceCategoriesLoading = loading => ({
  type: actionTypes.SET_SERVICE_CATEGORIES_LOADING,
  payload: loading,
});

export const setServiceCategoriesError = error => ({
  type: actionTypes.SET_SERVICE_CATEGORIES_ERROR,
  payload: error,
});

export const clearServiceCategories = () => ({
  type: actionTypes.CLEAR_SERVICE_CATEGORIES,
});

// Service Subcategories actions
export const setServiceSubcategories = subcategories => ({
  type: actionTypes.SET_SERVICE_SUBCATEGORIES,
  payload: subcategories,
});

export const setServiceSubcategoriesLoading = loading => ({
  type: actionTypes.SET_SERVICE_SUBCATEGORIES_LOADING,
  payload: loading,
});

export const setServiceSubcategoriesError = error => ({
  type: actionTypes.SET_SERVICE_SUBCATEGORIES_ERROR,
  payload: error,
});

export const clearServiceSubcategories = () => ({
  type: actionTypes.CLEAR_SERVICE_SUBCATEGORIES,
});

// Amenities actions
export const setAmenities = amenities => ({
  type: actionTypes.SET_AMENITIES,
  payload: amenities,
});

export const setAmenitiesLoading = loading => ({
  type: actionTypes.SET_AMENITIES_LOADING,
  payload: loading,
});

export const setAmenitiesError = error => ({
  type: actionTypes.SET_AMENITIES_ERROR,
  payload: error,
});

export const clearAmenities = () => ({
  type: actionTypes.CLEAR_AMENITIES,
});

export const setCartEntries = () => ({
  type: actionTypes.SET_ENTRIES,
  payload: [],
});

export const setHasItems = hasItems => ({
  type: actionTypes.HAS_ITEMS,
  payload: hasItems,
});

export const removeFromCartEntryList = entryId => {
  return {
    type: actionTypes.REMOVE_ENTRY,
    payload: entryId,
  };
};

export const updateBundleQuantity = payload => ({
  type: actionTypes.UPDATE_BUNDLE_QUANTITY,
  payload,
});

export const resetBundleQuantity = payload => ({
  type: actionTypes.RESET_BUNDLE_QUANTITY,
  payload,
});

export const saveOrderSummary = orderSummary => ({
  type: actionTypes.SAVE_ORDER_SUMMARY,
  payload: orderSummary,
});

// Payment Institutions actions
export const setPaymentInstitutions = paymentInstitutions => ({
  type: actionTypes.SET_PAYMENT_INSTITUTIONS,
  payload: paymentInstitutions,
});

export const setPaymentInstitutionsLoading = loading => ({
  type: actionTypes.SET_PAYMENT_INSTITUTIONS_LOADING,
  payload: loading,
});

export const setPaymentInstitutionsError = error => ({
  type: actionTypes.SET_PAYMENT_INSTITUTIONS_ERROR,
  payload: error,
});

export const clearPaymentInstitutions = () => ({
  type: actionTypes.CLEAR_PAYMENT_INSTITUTIONS,
});
